import { WarningTriangleIcon } from "@xola/icons";
import { Tooltip } from "@xola/ui-kit";
import React from "react";
import { NoTranslate } from "../../Common/NoTranslate";

interface ShowResourceNamesProps {
    content: any[];
    count: number;
    warning?: string | null;
    showOnlyCount?: boolean;
}

export const ShowResourceNames = ({ content, count, warning, showOnlyCount }: ShowResourceNamesProps) => {
    if (content.length === 1) {
        return (
            <div className="flex w-0 flex-grow flex-col">
                <div className="flex flex-grow">
                    <div className="w-12 xl:w-14 2xl:w-20">
                        <Tooltip content={<div className="grid grid-cols-1">{content}</div>}>
                            <NoTranslate as="div" className="truncate">
                                {showOnlyCount ? count : content[0] ?? 0}{" "}
                            </NoTranslate>
                        </Tooltip>
                    </div>
                    {warning && (
                        <div className="min-w-0 shrink-0">
                            <Tooltip content={warning}>
                                <span>
                                    <WarningTriangleIcon size="medium" className="relative -top-0.5 text-danger" />
                                </span>
                            </Tooltip>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <Tooltip content={<div className="grid grid-cols-1">{content}</div>}>
            {count}{" "}
            <span>
                {warning ? (
                    <Tooltip content={warning}>
                        <span>
                            <WarningTriangleIcon size="medium" className="relative -top-0.5 text-danger" />
                        </span>
                    </Tooltip>
                ) : null}
            </span>
        </Tooltip>
    );
};
